import React from 'react'

import "./TermsAndConditions.scss"

const TermsAndConditions = ({ handleTermsAndConditionsAccept, handleTermsAndConditionsReject }) => {
  return (
    <div className="modern-survey-body terms-and-conditions">
      <div className="terms-header">
        <h2 className="assessment-title">
          Algemene voorwaarden
        </h2>
      </div>
      <div className="terms-content">
        <div className="terms-section">
          <h3 className="section-title">Orthopaedic Treatment Outcomes System (OTOS)</h3>
          <p className="subtitle">
            Verklaring van toestemming voor gebruik van persoonlijke gegevens in OTOS.
          </p>
        </div>

        <div className="terms-section">
          <h4 className="subsection-title">Verantwoordelijke partijen</h4>
          <div className="contact-info">
            <p><strong>Aanbieder van het systeem:</strong><br />
            Dr. Dirk Petré, Orthopedie BV<br />
            Harelbekstraat 100, 8540 Deerlijk</p>
            
            <p><strong>Behandelende arts:</strong><br />
            Dr. Dirk Petré, Sint Jozefskliniek<br />
            Ommegangstraat 7, 8870 Izegem</p>
          </div>
        </div>

        <div className="terms-section">
          <h4 className="subsection-title">Wat is OTOS?</h4>
          <p>
            OTOS is een internet gebaseerd registratiesysteem voor het controleren van behandelingsresultaten op het gebied van orthopedie en meer specifiek voor ingrepen ter hoogte van de schouder en elleboog. 
          </p>
          <p>
            Door middel van OTOS kan mijn behandelende arts de gezondheidstoestand van mijn schouder en/of elleboog controleren waardoor zijn medische kennis over deze gewrichten kan worden verbeterd.
          </p>
        </div>

        <div className="terms-section">
          <h4 className="subsection-title">Gegevensbescherming</h4>
          <ul className="privacy-points">
            <li>Mijn behandelende arts is de enige verantwoordelijke persoon voor het verzamelen, verwerken en gebruik van de gegevens.</li>
            <li>Het verzamelen, verwerken en gebruik van de gegevens gebeurt met een privacyniveau dat adequaat is vanuit het oogpunt van Europees recht.</li>
            <li>Enkel mijn behandelende arts en zijn directe medewerkers hebben inzage in deze gegevens.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h4 className="subsection-title">Toestemming patiënt</h4>
          <p>
            Als patiënt verklaar ik mondeling en schriftelijk te zijn ingelicht over de relevantie van deelname aan OTOS. Ik heb genoeg tijd gehad om de bovenstaande patiënteninformatie te lezen, het te begrijpen en te beslissen of ik deze toestemming wil verlenen. 
          </p>
          <p>
            Ik heb genoeg mogelijkheden gehad om antwoorden te krijgen op mijn vragen door middel van een gesprek met mijn behandelend arts of een van zijn directe medewerkers.
          </p>
        </div>

        <div className="terms-section highlight-section">
          <h4 className="subsection-title">Intrekking toestemming</h4>
          <p>
            Als patiënt ben ik me bewust van het feit dat ik te allen tijde mijn toestemming mag intrekken, zonder opgave van reden en zonder dat daar kosten aan verbonden zijn.
          </p>
          <p className="contact-email">
            <strong>Contact:</strong> <a href="mailto:dirk.petre@sjki.be">dirk.petre@sjki.be</a>
          </p>
        </div>
      </div>
      <div className="modern-survey-footer">
        <button
          type="button"
          className="modern-btn modern-btn-error"
          onClick={handleTermsAndConditionsReject}
        >
          Weigeren
        </button>
        <button
          type="button"
          className="modern-btn modern-btn-success"
          onClick={handleTermsAndConditionsAccept}
        >
          Accepteren
        </button>
      </div>
    </div>
  )
}

export default TermsAndConditions